import { render, staticRenderFns } from "./registroUsuarios.vue?vue&type=template&id=73e2a458"
import script from "./registroUsuarios.vue?vue&type=script&lang=js"
export * from "./registroUsuarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports